// extracted by mini-css-extract-plugin
export default {"backButton":"TaskNavigationPanel_backButton__ZQCyV"};